const extractors = {
  adjustment: require('./extractors/adjustment'),
  grn: require('./extractors/grn'),
  rtv: require('./extractors/rtv'),
  sales_return: require('./extractors/sales-return'),
  invoice: require('./extractors/invoice'),
  zone_movement: require('./extractors/zone-movement')
}

// Cross-cutting wrapper above every Shipsy callback:
async function recordTransaction (type, payload, { mainApi, logger }) {
  // Extract stock_transactions rows from the payload (per-callback logic
  const extractor = extractors[type]
  if (!extractor) {
    throw new Error(`recordTransaction: unknown transaction type: ${type}`)
  }

  const rows = await extractor(payload, { mainApi })
  if (rows.length === 0) return []

  // Persist them via mainApi.stock.stockTransactions.
  await mainApi.stock.stockTransactions.bulkInsert(rows)
  return rows
}

module.exports = {
  recordTransaction,
  extractors
}
